export enum AutoComplete {
  On = 'on',
  Off = 'off',
}

export enum ButtonShape {
  Default = 'none',
  Square = 'square',
  StretchToFit = 'stretch',
}

export enum ButtonType {
  Button = 'button',
  Submit = 'submit',
}

export enum IconFont {
  AddCell_New = 'AddCell_New',
  AlertTriangle = 'AlertTriangle',
  Annotate_New = 'Annotate_New',
  ArrowDown_New = 'ArrowDown_New',
  ArrowLeft_New = 'ArrowLeft_New',
  ArrowRight_New = 'ArrowRight_New',
  BarChart_New = 'BarChart_New',
  Bell = 'Bell',
  Bill = 'Bill',
  BookCode = 'BookCode',
  BookOutline = 'BookOutline',
  Braces = 'Braces',
  BucketSolid = 'BucketSolid',
  Calendar = 'Calendar',
  CaretDown_New = 'CaretDown_New',
  CaretLeft_New = 'CaretLeft_New',
  CaretOutlineRight = 'CaretOutlineRight',
  CaretRight_New = 'CaretRight_New',
  CaretUp_New = 'CaretUp_New',
  Chat = 'Chat',
  CheckMark_New = 'Checkmark_New',
  ChangeState = 'ChangeState',
  CircleThick = 'CircleThick',
  Clipboard_New = 'Clipboard_New',
  Clock_New = 'Clock_New',
  Cloud = 'Cloud',
  CogOutline_New = 'CogOutline_New',
  CogSolid_New = 'CogSolid_New',
  CollapseLeft = 'CollapseLeft',
  CollapseRight = 'CollapseRight',
  CopperCoin = 'Coppercoin',
  CrownSolid_New = 'CrownSolid_New',
  Cube = 'Cube',
  CuboSolid = 'CuboSolid',
  CuboUniform = 'Cubouniform',
  CurrencyDollar = 'CurrencyDollar',
  Darkmode_New = 'Darkmode_New',
  DashH = 'DashH',
  Download_New = 'Download_New',
  Duplicate_New = 'Duplicate_New',
  ExpandB = 'ExpandB',
  Export_New = 'Export_New',
  EyeClosed = 'EyeClosed',
  EyeOpen = 'EyeOpen',
  Flask = 'Flask',
  FunnelSolid = 'FunnelSolid',
  GraphLine_New = 'GraphLine_New',
  Group = 'Group',
  History = 'History',
  Info_New = 'Info_New',
  Install = 'Install',
  Layers = 'Layers',
  Lightmode_New = 'Lightmode_New',
  Link = 'Link',
  Lock = 'Lock',
  Logout = 'Logout',
  More = 'More',
  Pause = 'Pause',
  Pencil = 'Pencil',
  PieChart = 'PieChart',
  Play = 'Play',
  Plus_New = 'Plus_New',
  QuestionMark = 'QuestionMark',
  QuestionMark_Outline = 'QuestionMark_Outline',
  Refresh_New = 'Refresh_New',
  Remove_New = 'Remove_New',
  Save = 'Save',
  Search_New = 'Search_New',
  Share = 'Share',
  Shield = 'Shield',
  SidebarClose = 'SidebarClose',
  SidebarOpen = 'SidebarOpen',
  Star = 'Star',
  StarSmile = 'StarSmile',
  Subscribe = 'Subscribe',
  Subtract = 'Subtract',
  Switch_New = 'Switch_New',
  Timer = 'Timer',
  Text_New = 'Text_New',
  Trash_New = 'Trash_New',
  Undo = 'Undo',
  Upload_New = 'Upload_New',
  Upload_Outline = 'Upload_Outline',
  User = 'User',
  Zap = 'Zap',
}

export enum Direction {
  Left = 'left',
  Right = 'right',
  None = 'none',
}

export enum InputType {
  Text = 'text',
  Number = 'number',
  Password = 'password',
  Email = 'email',
  Checkbox = 'checkbox',
  Range = 'range',
}
